import React, { useState } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function ImportarAcucarNy() {
  const [loading, setLoading] = useState(false);

  const props = {
    name: "file",
    action: `${process.env.REACT_APP_API_RB}/acoes_csv/importar-acucarny`,
    // headers: { "Content-Type": "multipart/form-data" },
    showUploadList: false,
    beforeUpload: () => setLoading(true),
    onChange(info) {
      if (info.file.status === "done") {
        message.success("Arquivo enviado com sucesso!");
        setLoading(false);
      } else if (info.file.status === "error") {
        message.error("Falha ao enviar arquivo.");
        setLoading(false);
      }
    },
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Importar Açúcar NY</h2>
      <Upload {...props} accept=".csv">
        <Button icon={<UploadOutlined />} loading={loading}>
          Selecionar arquivo CSV
        </Button>
      </Upload>
      <div style={{ marginTop: 16 }}>
        <b>Exemplo de CSV:</b>
        <pre style={{ background: "#f5f5f5", padding: 8 }}>
 Contratos/Periodo ;Fechamento;MÍNIMA;MÁXIMA;VOLUME ;POSIÇÃO EM ABERTO
        </pre>
      </div>
    </div>
  );
}
